export function isPolishLanguage(language) {
  return (language || "").toLowerCase().startsWith("pl");
}

export function isPolishCountry(countryCode) {
  return (countryCode || "").toUpperCase() === "PL";
}

export function shouldShowBlik({ language, countryCode } = {}) {
  return isPolishLanguage(language) || isPolishCountry(countryCode);
}

export function resolvePaymentProvider(option) {
  if (option === "paypal") return "paypal";
  return "stripe";
}
